// Colores base por defecto
const defaultColors = {
  primary: {
    text: {
      regular: '#03BAA1',
      strong: '#028876',
      weak: '#59FCE6',
    },
    bg: {
      regular: '#03BAA1',
      strong: '#01554A',
      weak: '#59FCE6',
      inverted: '#FFFFFF',
    },
    border: {
      regular: '#03BAA1',
      strong: '#01554A',
      weak: '#59FCE6',
      inverted: '#FFFFFF',
    },
    ic: {
      regular: '#03BAA1',
      strong: '#01554A',
      weak: '#59FCE6',
    },
  },
  'secondary-1': {
    text: {
      regular: '#02614B',
      strong: '#011813',
      weak: '#0FE5B4',
    },
    bg: {
      regular: '#02614B',
      strong: '#011813',
      weak: '#0FE5B4',
    },
    border: {
      regular: '#02614B',
      strong: '#011813',
      weak: '#0FE5B4',
    },
    ic: {
      regular: '#02614B',
      strong: '#011813',
      weak: '#0FE5B4',
    },
  },
  'secondary-2': {
    text: {
      regular: '#3D434C',
      strong: '#3D434C',
      weak: '#9EA2A8',
    },
    bg: {
      regular: '#3D434C',
      strong: '#1E2126',
      weak: '#9EA2A8',
    },
    border: {
      regular: '#3D434C',
      strong: '#1E2126',
      weak: '#9EA2A8',
    },
    ic: {
      regular: '#3D434C',
      strong: '#1E2126',
      weak: '#9EA2A8',
    },
  },
  neutral: {
    text: {
      regular: '#585053',
      strong: '#231F20',
      weak: '#A59CA0',
      muted: '#8C929C',
      inverted: '#FFFFFF',
    },
    bg: {
      regular: '#F5F7FA',
      strong: '#231F20',
      stronger: '#AEADC0',
      weak: '#A59CA0',
      muted: '#CCCCCC',
      'muted-strong': '#8C929C',
      inverted: '#FFFFFF',
    },
    border: {
      regular: '#585053',
      strong: '#231F20',
      weak: '#A59CA0',
      // Hairline frío del Figma Cementos UY: reglas de tabla, bandas vacías y
      // conectores del stepper. La escala neutral cálida no tiene equivalente.
      weaker: '#DFE6EB',
      inverted: '#A59CA0',
    },
    ic: {
      regular: '#585053',
      strong: '#231F20',
      weak: '#A59CA0',
      inverted: '#FFFFFF',
    },
  },
  danger: {
    text: {
      regular: '#C40303',
      strong: '#5F0101',
      weak: '#FD6363',
    },
    bg: {
      regular: '#C40303',
      strong: '#5F0101',
      weak: '#FD6363',
      inverted: '#FFFFFF',
    },
    border: {
      regular: '#C40303',
      strong: '#5F0101',
      weak: '#F78F89',
      inverted: '#C40303'
    },
    ic: {
      regular: '#C40303',
    },
  },
  warning: {
    text: {
      regular: '#A16108',
    },
    bg: {
      regular: '#A16108',
      strong: '#45331C',
      weak: '#F6F1E9',
    },
    border: {
      regular: '#A16108',
      strong: '#45331C',
      inverted: '#A16108',
    },
    ic: {
      regular: '#A16108',
    },
  },
  info: {
    text: {
      regular: '#3665B2',
    },
    bg: {
      regular: '#3665B2',
      strong: '#1F304C',
      weak: '#9EBAE8',
      inverted: '#E6EEFB',
    },
    border: {
      regular: '#3665B2',
      strong: '#1F304C',
    },
    ic: {
      regular: '#3665B2',
    },
  },
  success: {
    text: {
      regular: '#0C7339',
      strong: '#234E52',
    },
    bg: {
      regular: '#00AB92',
      strong: '#102B08',
      stronger: '#0C7339',
      weak: '#DDF0ED',
    },
    border: {
      regular: '#0C7339',
      strong: '#102B08',
      weak: '#7CBF9E',
      inverted: '#00AB92',
    },
    ic: {
      regular: '#0C7339',
    },
  },
  none: {
    text: {
      regular: '#0C7339',
    },
    bg: {
      regular: '#0C7339',
      strong: '#0C7339',
      stronger: '#0C7339',
      weak: '#0C7339',
    },
    border: {
      regular: '#0C7339',
      strong: '#102B08',
      weak: '#7CBF9E',
    },
    ic: {
      regular: '#0C7339',
    },
  },
};

// Exportar colores mutables para permitir personalización dinámica
export const colors = { ...defaultColors };

/**
 * Actualiza los colores primary y secondary-1 basados en un tema de cliente
 * Esta función permite cambiar los colores en runtime
 */
export function updateColorsWithClientTheme(clientColors: any) {
  if (clientColors.primary) {
    Object.assign(colors.primary, clientColors.primary);
  }
  if (clientColors['secondary-1']) {
    Object.assign(colors['secondary-1'], clientColors['secondary-1']);
  }
}

